const ZINDEX_LAYERS = {
  websiteSnackTabOverlay: 999,
  calendarMorePopover: 99,
  sidebar: 3,
  xngCheckbox: 0,
  xngCheckboxRipple: 1,
};

export default ZINDEX_LAYERS;
